import { ActionReducer } from '@ngrx/store';
import { ActionTypes } from '../actions/map-survey.action';
import * as MapConstants from '../../constants/map';
import * as CoreMapFunction from '../../map/coreMapFunction';

type InitialArcgisType = ArcGisType & {
    onClickMap: any;

    onMeasurementDrawComplete: (geometry: __esri.Geometry) => void;
};
const initialArcgis: InitialArcgisType = {
    mapView: null,
    drawerMeasurement: null,

    onClickMap: null,
    onMeasurementDrawComplete: null,
};
let arcgis = { ...initialArcgis };

const executeMapFunction = (mapFunction, param) => {
    mapFunction(arcgis, param);
};

const initMapEvent = () => {
    arcgis.mapView.on('click', (event: __esri.ViewClickEvent) => {
        if (arcgis.onClickMap) {
            arcgis.onClickMap(arcgis, event.mapPoint);
        }
    });
};

const initGraphicLayer = async () => {
    Object.keys(MapConstants.graphicLayerId).forEach((key) => {
        const layerID = MapConstants.graphicLayerId[key];
        CoreMapFunction.addLayerById(arcgis, layerID);
    });
};

const loadLayerTOC = async () => {};

const createDrawerMeasurement = () => {
    arcgis.drawerMeasurement = CoreMapFunction.createMeasurementDraw(
        arcgis,
        MapConstants.graphicLayerId.measurementLayer
    );
    arcgis.drawerMeasurement.on('create', (event) => {
        if (event.state === 'complete' && arcgis.onMeasurementDrawComplete) {
            arcgis.onMeasurementDrawComplete(event.graphic.geometry);
        }
    });
};

export const MapSurveyMiddleware = (
    reducer: ActionReducer<any>
): ActionReducer<any> => {
    return (state, action) => {
        const actionAny = action as any;
        switch (action.type) {
            case ActionTypes.InitMap:
                arcgis.mapView = actionAny.mapView;
                if (arcgis.mapView) {
                    initMapEvent();
                    loadLayerTOC();
                    initGraphicLayer();
                }
                return state;

            case ActionTypes.BindMapCommand:
                executeMapFunction(actionAny.mapFunction, actionAny.params);
                return state;

            case ActionTypes.BindEvtClickMap:
                arcgis.onClickMap = actionAny.callbackFunction;
                return state;

            case ActionTypes.DestroyMap:
                if (arcgis.mapView) {
                    arcgis.mapView.destroy();
                    arcgis = initialArcgis;
                }
                return state;

            case ActionTypes.InitDrawerMeasurement:
                if (arcgis.mapView) {
                    createDrawerMeasurement();
                }
                return state;
            case ActionTypes.BindEvtCompleteDrawerMeasurement:
                arcgis.onMeasurementDrawComplete = actionAny.callbackFunction;
                return state;
            case ActionTypes.DestroyMeasurement:
                if (arcgis.drawerMeasurement) {
                    arcgis.drawerMeasurement.destroy();
                    arcgis.drawerMeasurement = null;
                }
                return state;
            case ActionTypes.DrawGraphic:
                if (arcgis.mapView) {
                    CoreMapFunction.addPointGraphic(arcgis, actionAny.params);
                }
                return state;

            case ActionTypes.DrawHighlight:
                if (arcgis.mapView) {
                    CoreMapFunction.addHighlightGraphic(
                        arcgis,
                        actionAny.params
                    );
                }
                return state;
            case ActionTypes.DrawPointHighlight:
                if (arcgis.mapView) {
                    CoreMapFunction.addPointHightlight(
                        arcgis,
                        actionAny.params
                    );
                }
                return state;
            default:
                const nextState = reducer(state, action);
                return nextState;
        }
    };
};
